export interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}
export interface ExtractedLocation {
  latitude: number;
  longitude: number;
  address: string;
  streetNumber?: string;
  restOfAddress?: string;
  city?: string;
  country?: string;
  country_obj: {
    code: string;
    name: string;
  };
  postal_code?: string;
  state?: string;
  street: string;
}

export const extractAddressComponents = (
  addressComponents: AddressComponent[], // Address components from Google Maps API
  latitude: number,
  longitude: number,
  description: string
): ExtractedLocation => {
  // Extract street number
  const streetNumberComponent = addressComponents.find((component) =>
    component.types.includes('street_number')
  );
  const streetNumber = streetNumberComponent
    ? streetNumberComponent.long_name
    : undefined;

  // Extract city
  const city = addressComponents.find((component) =>
    component.types.includes('locality')
  )?.long_name;

  // Extract country details
  const countryComponent = addressComponents.find((component) =>
    component.types.includes('country')
  );
  const country = countryComponent?.long_name;

  const country_obj = {
    code: countryComponent?.short_name || '',
    name: countryComponent?.long_name || '',
  };

  // Extract postal code
  const postalCodeComponent = addressComponents.find((component) =>
    component.types.includes('postal_code')
  );
  const postal_code = postalCodeComponent
    ? postalCodeComponent.long_name
    : undefined; // Return `undefined` instead of `null`

  // Extract state
  const state = addressComponents.find((component) =>
    component.types.includes('administrative_area_level_1')
  )?.short_name;

  // Extract street name
  const streetNameComponent = addressComponents.find((component) =>
    component.types.includes('route')
  );
  const streetName = streetNameComponent ? streetNameComponent.long_name : '';

  // Construct the street address
  const street = `${streetNumber} ${streetName}`.trim();

  // Collect remaining address components (without street number)
  const restOfAddress = addressComponents
    .filter((component) => !component.types.includes('street_number'))
    .map((component) => component.long_name)
    .join(', ');

  // Return the structured address data
  return {
    latitude,
    longitude,
    address: description,
    streetNumber,
    restOfAddress,
    city,
    country,
    country_obj,
    postal_code,
    state,
    street,
  };
};
